const moment = require('moment')

export default {
  namespaced: true,
  state: {
    items: [],
    types: [{
        value: "bill",
        text: "Facture"
      },
      {
        value: "credit",
        text: "Avoir"
      },
      {
        value: "loss",
        text: "Perte"
      }
    ],
  },
  getters: {
    getAll: state => state.items,
    getItem: state => id => state.items.find(item => item.id == id),
    getTypes: state => state.types,
    getType: state => type => state.types.find(item => item.value == type),
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'manualbilling',
        api_data_path: 'manualBillings',
        namespace: 'manual_billing'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {id, wait = false}) => {
      let params = {
        wait: wait,
        api_url: 'manualbilling',
        namespace: 'manual_billing',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'manualbilling',
        namespace: 'manual_billing',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'manualbilling',
        namespace: 'manual_billing',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'manualbilling',
        namespace: 'manual_billing',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/manual_billing.js